import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var MLPackageVersionsService = /** @class */ (function (_super) {
    tslib_1.__extends(MLPackageVersionsService, _super);
    function MLPackageVersionsService(http) {
        var _this = _super.call(this, http, MapperService.mlPackageVersionMap) || this;
        _this._endpoint = '/odata/MLPackageVersions';
        return _this;
    }
    MLPackageVersionsService.prototype.getVersions = function (mlPackageVersion, queryOptions) {
        return this.get(queryOptions, "/odata/MLPackageVersions/UiPath.Server.Configuration.OData.GetMLPackageVersions(mlPackageId='" + mlPackageVersion + "')");
    };
    MLPackageVersionsService.prototype.getVersionById = function (mlPackageId, mlPackageVersion, queryOptions) {
        return this.get(queryOptions, "/odata/MLPackageVersions/UiPath.Server.Configuration.OData.GetMLPackageVersionById(\n            mlPackageId='" + mlPackageId + "',mlPackageVersionId='" + mlPackageVersion + "')");
    };
    return MLPackageVersionsService;
}(ODataService));
export { MLPackageVersionsService };
